import { SET_LIST_COURSE } from './courseConst'

export function setListCourse(course) {
  return {
    type: SET_LIST_COURSE,
    course
  };
}
